module.exports = __webpack_public_path__ + "media/images/svg/plus-icon-94f900b182cec06768909b87152d18e7.svg";